<template>
  <b-card
    no-body
    :class="{ open: visible }"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-header
      :class="{ collapsed: visible }"
      :aria-expanded="visible && checkbox ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click="updateVisible(!visible, 'vi')"
    >
      <slot name="header">
        <b-form-checkbox
          @change="updateVisible(checkbox, 'ch')"
          v-model="checkbox"
          class="custom-control-danger"
        ></b-form-checkbox>
        <span class="lead collapse-title">{{ title }}</span>
      </slot>
    </b-card-header>

    <b-collapse
      :disabled="!checkbox"
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <b-card-body>
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCollapse,
  BFormCheckbox,
} from "bootstrap-vue";
import { v4 as uuidv4 } from "uuid";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
    BFormCheckbox,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      checkbox: false,
      visible: false,
      collapseItemID: "",
      openOnHover: this.$parent.hover,
    };
  },
  computed: {
    accordion() {
      return this.$parent.accordion
        ? `accordion-${this.$parent.collapseID}`
        : null;
    },
  },
  created() {
    this.collapseItemID = uuidv4();
    this.visible = this.isVisible;
  },
  methods: {
    onCheck() {
      console.log(this.checkbox);
    },
    updateVisible(val, mode) {
      console.log(this.checkbox);
      console.log(this.visible);
      console.log("mode", mode);

      if (this.checkbox) {
        this.visible = val;
        this.$emit("visible", val);
      } else {
        if (this.visible) {
          this.visible = false;
          this.$emit("visible", false);
        } else {
          this.checkbox = true;
          this.visible = true;
          this.$emit("visible", true);
        }
      }
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true);
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false);
    },
  },
};
</script>
